export const renderVoltage = props => {
    if (!props) {
        return ''
    }

    const { show_voltage, voltage_label, voltage_list, a11y_voltage_label } = props

    if (!show_voltage || !voltage_label || !voltage_list || !voltage_list.length) {
        return ''
    }

    const voltageItem = voltage_list
        .map(({ label, url }) => {
            if (url) {
                return `<a href="${url}" target="_self"><span class="t-sm-400">${label}</span></a>`
            }

            return `<div aria-current="page"><span class="t-sm-700">${label}</span></div>`
        })
        .join('')

    return `<div class="cb-sku-tab">
        <span class="sr-only">${a11y_voltage_label}</span>
        <p class='t-sm-400' aria-hidden="true">${voltage_label}</p>
        ${voltageItem}
    </div>`
}
